export const FETCH_TRACKING_REQUEST = `@TRACKING/FETCH_TRACKING_REQUEST`
export const FETCH_TRACKING_SUCCESS = `@TRACKING/FETCH_TRACKING_SUCCESS`
export const FETCH_TRACKING_FAILED = `@TRACKING/FETCH_TRACKING_FAILED`
